/**
 * @namespace user
 */

export * from './getUserInfo';
export * from './postComment';
export * from './login';
export * from './loginQQ';
export * from './postAnswer';
export * from './deleteAccount';



// WEBPACK FOOTER //
// ../src/jsbridge/package/src/api/user/index.js